import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import RugianoProjectForm from "components/form/RugianoProjectForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Progetto creato con successo",
        errorMsg: "Errore nella creazione del progetto",
        navigateTo: { link: "/progetti-rugiano/:projectId/modifica", id: "projectId" },
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function NuovoProgettoRugiano() {
    return (
        <GridColumn>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Nuovo progetto</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <RugianoProjectForm />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default NuovoProgettoRugiano;
